/* Page sections the admin can reorder / hide from /admin/landing. `id` = the on-page anchor nav links scroll to. */
export const SECTION_META = [
  { key: 'hero', id: 'top', title: 'Hero', emoji: '🦸', locked: true },
  { key: 'teacher', id: 'proof', title: 'About your teacher', emoji: '👨‍🏫' },
  { key: 'pains', id: 'sounds-like-you', title: 'Sounds like you?', emoji: '✅' },
  { key: 'whats_inside', id: 'whats-inside', title: "Here's what's inside", emoji: '🎁' },
  { key: 'compare', id: 'why', title: 'Why this works better', emoji: '⚖️' },
  { key: 'how', id: 'how-it-works', title: 'How it works', emoji: '🪜' },
  { key: 'results', id: 'results', title: 'Watch the results', emoji: '🎬' },
  { key: 'faq', id: 'faq', title: 'FAQ', emoji: '❓' },
  { key: 'final_cta', id: null, title: 'Final CTA (dark box above the footer)', emoji: '🚀' },
];

const META = Object.fromEntries(SECTION_META.map(m => [m.key, m]));

/* Mirrors backend normalize_layout(): known keys, no duplicates, missing appended, hero first + visible. */
export function orderedSections(layout) {
  const seen = new Set();
  const rows = [];
  for (const r of (layout?.sections || [])) {
    if (META[r?.key] && !seen.has(r.key)) { seen.add(r.key); rows.push({ ...META[r.key], visible: r.visible !== false }); }
  }
  for (const m of SECTION_META) if (!seen.has(m.key)) rows.push({ ...m, visible: true });
  rows.sort((a, b) => (a.key === 'hero' ? 0 : 1) - (b.key === 'hero' ? 0 : 1));
  rows[0].visible = true;
  return rows;
}

export const toLayout = rows => ({ sections: rows.map(r => ({ key: r.key, visible: r.visible })) });
